import type { MemberNames } from "./useMemberNames";

/**
 * A person as a sentence's values name them, `{ name, context }`, passed to `t` as its options.
 * A type, not an interface: `t`'s options need its implicit index signature.
 */
export type NamedPerson = {
  readonly name: string;
  /** `"you"` where the person is the viewer: the sentence's `_you` form says it as the language does. */
  readonly context: "you" | undefined;
};

/**
 * The person a sentence names (F155): by name, or, where they are the viewer, through the
 * sentence's own "you" form, since German says "von Ihnen", never "von Sie", and English
 * "Your working state", not "Working state of you".
 */
export function namedPerson(people: Pick<MemberNames, "nameOf" | "currentUserId">, userId: string): NamedPerson {
  return { name: people.nameOf(userId), context: userId === people.currentUserId ? "you" : undefined };
}
